import get from 'lodash.get';
import serverVars from 'server-vars';
import { getMeasurementUnit } from 'dibs-intl/exports/intlSupport';

export const getRoomViewItem = ({ item, user }) => {
    const locale = serverVars.get('locale');
    const measurementUnit = user
        ? get(user, 'profile.measurementUnit')
        : getMeasurementUnit(locale);
    const displayWidth = get(item, 'measurement.hoverDimensionsWidth') || [];
    const displayHeight = get(item, 'measurement.hoverDimensionsHeight') || [];
    const dimensionWidth = displayWidth.find(dim => dim.unit === measurementUnit);
    const dimensionHeight = displayHeight.find(dim => dim.unit === measurementUnit);
    const inchesWidth = get(item, 'measurement.convertedMeasurements.width');
    const inchesHeight = get(item, 'measurement.convertedMeasurements.height');
    const src = get(item, 'photos[0].largePath');

    return {
        src,
        inchesDimensions: {
            width: inchesWidth,
            height: inchesHeight,
        },
        displayDimensions: {
            width: dimensionWidth && dimensionWidth.value,
            height: dimensionHeight && dimensionHeight.value,
        },
    };
};
